
    // this file was auto generated by python script
    import Save from './Save';
    export default Save;
    